import React from 'react'
import { useSelector } from 'react-redux'
import BackupReconsTable from '../Backup365ReconsTable'
import { Card, CardBody } from 'reactstrap'

const BackupReconsTab = () => {
  const backupRecons = useSelector((state) => state.backup365Reports.backupRecons)

  if (!backupRecons || backupRecons.length === 0) return <div className="text-muted">No reconciliation data found.</div>

  return (
    <Card className="shadow-sm border-0">
      <CardBody>
        <BackupReconsTable companies={backupRecons} />
      </CardBody>
    </Card>
  )
}

export default BackupReconsTab
